import { PlusOutlined } from "@ant-design/icons";
import { Button, Layout, Menu } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "../styles/PaymentMenu.module.css";


const PaymentPeriodMenu = ({ className = "", onAddMenu = () => { }, onChange = () => { }, children, dataSource = [], employmentSetupOptions = [], employmentDataByKey = [] }) => {
  const [selectedKeys, setSelectedKeys] = useState(employmentDataByKey?.id);

  const { t } = useTranslation();

  const onMenuClick = (e, value) => {
    setSelectedKeys([e.key]);
    onChange(e.key);
  };

  return (
    <Layout
      style={{
        backgroundColor: 'transparent'
      }}
      hasSider={false}
    >
      <Header style={{
        padding: 0,
        backgroundColor: 'transparent',
      }}>
        <Button onClick={onAddMenu} style={{ width: "max-content" }}><PlusOutlined /> {t('add-employment-type')}</Button>
        <Menu
          className={styles.menu}
          // defaultSelectedKeys={selectedKeys}
          selectedKeys={employmentDataByKey?.id}
          mode="inline"
          items={employmentSetupOptions}
          onClick={onMenuClick}
        />
      </Header>
      <Content
        // className={styles.content}
        style={{
          width: "100%",
          // margin: '8px 8px',
          // padding: 10,
          borderRadius: 0,
        }}
      >
        <div style={{
          minHeight: "30vh",
          minWidth: "30vh",
          width: "100%",
        }}>
          {children}
        </div>
      </Content>
    </Layout>
  );
};

export default PaymentPeriodMenu;
